import { DateDuration } from "../../system";
import {
  WorkflowStatusName,
  ReceptionReportType,
  ReceptionDeliveryKind,
  ReceptionDetailListItem,
  ReceptionInputSection,
  ReceptionDetailListColor,
  ReceptionListCardStyleDispInfo,
} from "../items";
import { ReceptionListDispInfoBase } from "../base";
import { WorkflowListActionKinds, WorkflowStatusKinds } from "../kinds";
import Enumerable from "linq";

// 依頼文書一覧画面表示用model
export class ReceptionDetailListDispInfo extends ReceptionListDispInfoBase {
  constructor() {
    super();
    this.workflowStatuses = [];
    this.deliveryKindList = [];
  }

  // 一時退避運用有無
  public isSuspendStatusEnable: boolean;

  // 他医依頼運用有無
  public isRequestAnotherEnable: boolean;

  // WFステータスリスト
  public workflowStatuses: WorkflowStatusName[];

  // すべてタブのデフォルト選択する進捗コード
  public defaultSelectedWorkflowStatusCodeList: number[];

  // 文書種別リスト
  public reportTypes: ReceptionReportType[];

  // 初期検索対象期間
  public defaultSearchPeriod: DateDuration;

  // 交付方法リスト
  public deliveryKindList: ReceptionDeliveryKind[];

  // リスト項目設定
  public displayItemList: ReceptionDetailListItem[];

  // WF一覧のダブルクリック動作
  workflowListDoubleClickAction: WorkflowListActionKinds;

  displayColor: ReceptionDetailListColor;

  // 入力部署リスト
  public inputSectionList: ReceptionInputSection[];

  // カードスタイル設定
  public cardStyle: ReceptionListCardStyleDispInfo;

  /**
   * 種別を指定してWFステータスを取得
   * @param type 
   */
  getWorkflowStatuses(type: WorkflowStatusKinds): WorkflowStatusName[] {
    return Enumerable.from(this.workflowStatuses).where(m => m.type === type).toArray();
  }
}
